import { Stack } from "@fluentui/react";
import React, { FC } from "react";
import Moment from "react-moment";
import { DailyReportNominationItem } from "../../models";
import SofIcon from "../common/Icons";
import "./Reports.css";

type Props = {
  dailyReport: DailyReportNominationItem;
  reportType: string;
  includeComments: boolean;
  selectedItem: boolean;
};

const TruckPrintPage: FC<Props> = (props: Props) => {
  // const summaryNominationCount =
  //   props.dailyReport.longDockLogReport.nominations.filter(
  //     (n) => n.isSelected
  //   ).length;
  // const detailsNominationCount = props.dailyReport.nominations.filter(
  //   (n) => n.isSelected
  // ).length;
  // const lastDetailsRecord = props.dailyReport.nominations
  //   .filter((n) => n.isSelected)
  //   .slice(-1)[0];

  return (
    <>
      {props.reportType == "Details" && (
        <table>
          <thead>
            <Stack tokens={{ childrenGap: 20 }} horizontal>
              <div
                style={{
                  borderRight: "0.5px solid #E2E6E8",
                  paddingRight: "20px",
                  marginBottom: "25px",
                }}
              >
                <img
                  src="/logo-yellow.svg"
                  style={{ width: 80.25, height: 48 }}
                />
              </div>
              <div
                style={{
                  paddingRight: "15px",
                  paddingLeft: "5px",
                }}
              >
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                  }}
                >
                  Statement of Facts Summary Reports
                </div>
                <div>QADWorks Technical Solutions Inc</div>
              </div>
            </Stack>

            <div
              style={{
                backgroundColor: "black",
                height: "40px",
                paddingTop: "5px",
                paddingLeft: "15px",
                color: "white",
                marginBottom: "10px",
              }}
            >
              <table style={{ width: "100%", color: "white" }}>
                <tr>
                  <td style={{ width: "50%" }}>
                    <span
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                    >
                      {props.dailyReport.tank}
                    </span>
                  </td>
                  <td style={{ width: "25%" }}>
                    Nomination #:{" "}
                    <strong>
                      {`${props.dailyReport.nominationNo.substr(
                        props.dailyReport.nominationNo.length - 5
                      )}`}
                    </strong>
                  </td>

                  <td style={{ width: "25%" }}>
                    {" "}
                    Departed:{" "}
                    <strong>
                      {props.dailyReport.departureDate && (
                        <Moment
                          format="LL"
                          local
                        >{`${props.dailyReport.departureDate} UTC`}</Moment>
                      )}
                    </strong>
                  </td>
                </tr>
              </table>
            </div>
          </thead>

          <tbody>
            <table className={"pagebreak"}>
              <tr>
                <td>
                  <div
                    style={{
                      marginTop: "15px",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "black",
                        height: "40px",
                        paddingTop: "5px",
                        paddingLeft: "15px",
                        color: "white",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                        }}
                      >
                        {`Nomination# ${props.dailyReport.nominationNo.substr(
                          props.dailyReport.nominationNo.length - 6
                        )}`}
                      </span>
                    </div>

                    <div style={{ border: "0.5px solid #E2E6E8" }}>
                      <table className="tbl-report-border">
                        <tr>
                          <td>Tank:</td>
                          <td>
                            <strong>{props.dailyReport.tank}</strong>
                          </td>
                          <td>Loading Spot:</td>
                          <td>
                            <strong>{props.dailyReport.loadingSpot}</strong>
                          </td>
                        </tr>

                        <tr>
                          <td>Container Type:</td>
                          <td>
                            <strong>{props.dailyReport.truckType}</strong>
                          </td>
                          <td>Surveyor:</td>
                          <td>
                            <strong>{props.dailyReport.surveyor}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>Product:</td>
                          <td>
                            <strong>{props.dailyReport.product}</strong>
                          </td>
                          <td>Quantity:</td>
                          <td>
                            <strong>{props.dailyReport.quantity}</strong>
                          </td>
                        </tr>

                        <tr>
                          <td>Customer:</td>
                          <td>
                            <strong>{props.dailyReport.customer}</strong>
                          </td>
                          <td>Customer Order #:</td>
                          <td>
                            <strong>{props.dailyReport.customerOrderNo}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>Samples Count:</td>
                          <td>
                            <strong>{props.dailyReport.samplingCount}</strong>
                          </td>
                          <td></td>
                          <td>
                            <strong></strong>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  {props.selectedItem && (
                    <>
                      <table
                        className="tbl-report"
                        style={{
                          marginTop: "15px",
                        }}
                      >
                        <tr className="report-header-gray">
                          <td>Description</td>
                          <td>Date</td>
                          <td>Time</td>
                          <td>Delay Reason</td>
                          <td>Delay Duration</td>
                          <td>Status</td>
                        </tr>

                        {props.dailyReport.nominationActivities.map(
                          (activity: any) => (
                            <tr>
                              <td>{activity.description}</td>
                              <td>
                                {activity.executionDate && (
                                  <Moment format="ll" local>
                                    {`${activity.executionDate} UTC`}
                                  </Moment>
                                )}
                                {!activity.executionDate && "-"}
                              </td>
                              <td>
                                {activity.executionDate && (
                                  <Moment format="HH:mm" local>
                                    {`${activity.executionDate} UTC`}
                                  </Moment>
                                )}
                                {!activity.executionDate && "-"}
                              </td>
                              <td>
                                {activity.delayReason && activity.delayReason}
                                {!activity.delayReason && "-"}
                              </td>
                              <td>
                                {activity.delayReason && activity.delayDuration}
                                {!activity.delayReason && "-"}
                              </td>
                              <td
                                style={{
                                  color: `${
                                    activity.status === "Done" ? "#4CAF50" : ""
                                  }`,
                                }}
                              >
                                {activity.status}
                              </td>
                            </tr>
                          )
                        )}
                      </table>

                      {props.includeComments &&
                        props.dailyReport.comments.length > 0 && (
                          <table
                            style={{
                              width: "100%",
                              tableLayout: "fixed",
                            }}
                          >
                            <tr>
                              <td>
                                <div
                                  style={{
                                    fontSize: "20px",
                                    fontWeight: "bold",
                                    paddingRight: "15px",
                                    margin: "10px 0",
                                    color: "#00447E",
                                  }}
                                >
                                  Comments
                                </div>
                              </td>
                            </tr>

                            {props.dailyReport.comments.map((comment) => (
                              <tr>
                                <td>
                                  <div
                                    style={{
                                      border: "0.5px solid #E2E6E8",
                                      padding: "5px 5px 15px 5px",
                                    }}
                                  >
                                    <Stack
                                      tokens={{ childrenGap: 20 }}
                                      horizontal
                                    >
                                      <strong>
                                        {comment.submittedByName}{" "}
                                      </strong>
                                      <div style={{ color: "E2E6E8" }}>
                                        {"•"}&nbsp;&nbsp;
                                        <Moment
                                          format="ll HH:mm"
                                          local
                                        >{`${new Date(
                                          comment.submittedOn
                                        )} UTC`}</Moment>
                                      </div>
                                    </Stack>
                                    <div
                                      style={{
                                        whiteSpace: "pre-wrap",
                                      }}
                                    >
                                      {comment.commentText}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </table>
                        )}
                    </>
                  )}
                </td>
              </tr>
            </table>
          </tbody>

          <tfoot></tfoot>
        </table>
      )}
    </>
  );
};

export default TruckPrintPage;
